import React from "react";
import {Form, Table} from "react-bootstrap";
import AnalysisCard from "./AnalysisCard.jsx";
import HeaderWithHelp from "./HeaderWithHelp.jsx";
import {formatDateDE, formatEuroWhole} from "./format.js";

/**
 * "Früher gekauft, jetzt nicht mehr": Artikel mit Umsatz über der Schwelle
 * in einem Vorjahr, aber ohne Umsatz im Vorjahr und im Bezugsjahr (Ende des
 * gewählten Zeitraums, höchstens das laufende Jahr)
 * (Regel siehe schnittstelle.md). Die Schwelle ist einstellbar und liegt
 * beim Aufruf der Seite (Kunde.jsx), weil sie ein eigener Server-Parameter
 * ist und einen neuen Abruf auslöst.
 */
export default function CustomerLapsedTable({rows, threshold, onThresholdChange, loading, error}) {
    return (
        <AnalysisCard
            title="Früher gekauft, jetzt nicht mehr"
            help="Artikel mit Umsatz über der Schwelle in einem Jahr vor dem Vorjahr, aber ohne Umsatz im Vorjahr und im Bezugsjahr. Bezugsjahr ist das letzte Jahr des gewählten Zeitraums (höchstens das laufende Jahr) - dieselbe Regel wie für alle übrigen Zahlen der Seite."
            loading={loading}
            error={error}
            empty={!loading && (rows || []).length === 0}
            actions={
                <div className="d-flex align-items-center gap-2">
                    <Form.Label className="small text-muted mb-0" htmlFor="va-lapsed-threshold">
                        <HeaderWithHelp help='Mindestumsatz in einem Jahr vor dem Vorjahr, ab dem ein Artikel als „früher gekauft" zählt.'>
                            Schwelle
                        </HeaderWithHelp>
                    </Form.Label>
                    <Form.Control
                        id="va-lapsed-threshold"
                        type="number"
                        size="sm"
                        min={0}
                        step={10}
                        style={{width: 100}}
                        value={threshold}
                        onChange={(event) => onThresholdChange(event.target.value)}
                    />
                    <span className="small text-muted">€</span>
                </div>
            }
        >
            <div className="table-responsive">
                <Table size="sm" hover className="mb-0 align-middle">
                    <thead>
                        <tr>
                            <th>Artikel</th>
                            <th>Produktlinie</th>
                            <th className="text-end">Letztes Jahr mit Umsatz</th>
                            <th className="text-end">Letzter Umsatz</th>
                            <th>Letzter Beleg</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(rows || []).map((row) => (
                            <tr key={row.article_number}>
                                <td>{row.article_number} – {row.article_name}</td>
                                <td>{row.product_line || "Nicht zugeordnet"}</td>
                                <td className="text-end text-nowrap">{row.last_year_with_sales}</td>
                                <td className="text-end text-nowrap">{formatEuroWhole(row.last_amount)}</td>
                                <td>{formatDateDE(row.last_document_date)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </AnalysisCard>
    );
}
